import { lazy } from 'app/lazy'
import { LazyLoad } from 'features/common/ui/LazyLoad'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'
import ClientContext from 'features/common/ui/ClientContext'
import { Client } from 'features/common/utils/clientParameter'

const WorkflowsPage = lazy(() => import('./Routes/WorkflowsPage'))

const routes = {
  path: 'workflows',
  element: <AuthenticatedRoute element={<ClientContext client={Client.WorkflowsUI} />} allowGuestAccess />,
  children: [
    {
      index: true,
      element: (
        <LazyLoad>
          <WorkflowsPage />
        </LazyLoad>
      )
    }
  ]
}

export default routes
